import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HOME_COPY } from '../data/home-microempresario.content';

export type HomeInfoModalVariant = 'sin-cobertura' | 'sin-ofertas';

/**
 * Modal v2 para estados SIN OFERTAS (8) y SIN COBERTURA (20/22).
 */
@Component({
  selector: 'app-home-info-modal',
  templateUrl: './home-info-modal.component.html',
  styleUrls: ['./home-info-modal.component.scss'],
  standalone: false,
})
export class HomeInfoModalComponent {
  @Input() open = false;
  @Input() variant: HomeInfoModalVariant = 'sin-cobertura';
  @Input() finalizando = false;

  @Output() closed = new EventEmitter<void>();
  @Output() finalizar = new EventEmitter<void>();

  readonly copy = HOME_COPY.modalInfoEstado;

  get titulo(): string {
    return this.variant === 'sin-ofertas'
      ? this.copy.sinOfertas.titulo
      : this.copy.sinCobertura.titulo;
  }

  get mensaje(): string {
    return this.variant === 'sin-ofertas'
      ? this.copy.sinOfertas.mensaje
      : this.copy.sinCobertura.mensaje;
  }

  get linkHref(): string | null {
    return this.variant === 'sin-ofertas'
      ? this.copy.sinOfertas.cursoHref
      : null;
  }

  get linkLabel(): string | null {
    return this.variant === 'sin-ofertas'
      ? this.copy.sinOfertas.cursoLabel
      : null;
  }

  onClose(): void {
    if (this.finalizando) {
      return;
    }
    this.closed.emit();
  }

  onFinalizar(): void {
    if (this.finalizando) {
      return;
    }
    this.finalizar.emit();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
